<h3>No {{ name }}s Found!</h3>
<p>Would you like to create a new {{ name }}?</p>
<p><a class="btn btn-primary" [routerLink]="[link]">Create a New {{ name }}</a></p>
